import logo from "../imagens/lgAman.png";
import "./Header.css";
export default function Header() {
    return (
        <header>
            <div className="conteudo">
                <img className="logo" src={logo} alt="logo" />
                <div className="botaoAcao" onClick={() => window.location.href="#contatos"}></div>
            </div>
        </header>
    );
}
